export default "__VITE_ASSET__BOgHHr8B__"